import { Loading } from 'src/shared/components/ui/loaders/loading';
import ShimmerLoader from 'src/shared/components/ui/loaders/shimmer-loader';
import { Card } from 'src/shared/components/ui/card';
import { Separator } from 'src/shared/components/ui/separator';

/**
 * Skeleton matching the automation / flow editor layout.
 * Used as a `pendingComponent` so the transition from the list
 * view (with SideNav) to the full-screen editor feels instant
 * instead of flashing a generic spinner.
 */
export function FlowEditorSkeleton() {
  return (
    <div className="w-full h-screen">
      <div className="grid grid-cols-3 relative w-full bg-white items-center px-2 h-[45px]">
        <div className="flex items-center gap-1">
          <div className="w-7 h-7 rounded bg-gray-100 animate-pulse" />
          <ShimmerLoader width={200} height={18} />
        </div>
        <div className="flex justify-center">
          <div className="h-9 w-56 rounded-md bg-gray-50 animate-pulse" />
        </div>
        <div className="flex gap-1 items-center justify-end">
          <div className="h-7 w-16 rounded bg-gray-50 animate-pulse" />
          <div className="h-7 w-16 rounded bg-gray-50 animate-pulse" />
          <div className="h-7 w-16 rounded bg-gray-50 animate-pulse" />
        </div>
      </div>
      <Separator />
      <div className="w-full h-[calc(100vh-46px)] flex relative">
        <div className="relative w-full h-full flex justify-center">
          <div className="absolute top-0 left-0 bg-muted w-full h-full" />
          <Card
            className="bg-white shadow-lg gap-3 items-center justify-center flex h-20 w-80 mt-40 relative"
            style={{ zIndex: 100 }}
          >
            <p className="text-slate-700">Getting your automation ready</p>
            <Loading />
          </Card>
        </div>
      </div>
    </div>
  );
}
